// extracted by mini-css-extract-plugin
export default {"btn":"addButton_btn__iqW8k"};